module.exports = __webpack_public_path__ + "img/bucuresti-mosilor.c5de424d.jpg";